<header class="page-header">
  <div>
    <h1>Macchinari</h1>
    <p>Archivio e QR per l'uso in campo</p>
  </div>
  <button type="button" class="primary" (click)="showForm.set(!showForm())">
    {{ showForm() ? 'Annulla' : 'Nuovo macchinario' }}
  </button>
</header>

@if (showForm()) {
  <form class="form-panel" (ngSubmit)="create()">
    <label>Nome <input [(ngModel)]="form.name" name="name" required /></label>
    <label>Produttore <input [(ngModel)]="form.manufacturer" name="manufacturer" /></label>
    <label>Modello <input [(ngModel)]="form.model" name="model" /></label>
    <label>Matricola <input [(ngModel)]="form.serial_number" name="serial_number" /></label>
    <label>Ubicazione <input [(ngModel)]="form.location" name="location" /></label>
    <label class="full">Note <textarea [(ngModel)]="form.notes" name="notes" rows="2"></textarea></label>
    <button type="submit" class="primary">Salva</button>
  </form>
}

<table class="data-table">
  <thead>
    <tr>
      <th>Nome</th>
      <th>Produttore / Modello</th>
      <th>Ubicazione</th>
      <th>Scadute</th>
      <th>Da fare</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (m of machines(); track m.id) {
      <tr>
        <td>{{ m.name }}</td>
        <td>{{ m.manufacturer || '—' }} {{ m.model || '' }}</td>
        <td>{{ m.location || '—' }}</td>
        <td>
          <span [class.badge-warn]="m.overdue_count > 0">{{ m.overdue_count }}</span>
        </td>
        <td>{{ m.pending_count }}</td>
        <td><a [routerLink]="['/machines', m.id]">Apri</a></td>
      </tr>
    }
  </tbody>
</table>
